import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  Icon,
  IconSize,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useTranslation } from 'react-i18next';

import { useInvoiceContext } from '@app/feature/invoice/invoice.context';

export const InformationCardComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const invoice = useInvoiceContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card gap={GapEnum.M}>
      <Stack gap={GapEnum.M} justifyContent="space-between">
        <Stack flex={1}>
          <AccentTitle
            icon="info-circle"
            as={HeadingEnum.H2}
            text={t('$.invoice-details.information.title')}
          />
        </Stack>

        <Stack flex={1}>
          <Tag flex={1} className="bg-surface-brand">
            <Text bold>
              {t(`delmonicos-shared-sdk.enums-invoice-type.${invoice.type}`)}
            </Text>
          </Tag>
        </Stack>
      </Stack>

      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1} gap={GapEnum.XS} alignItems="center">
          <Icon name="building-01" iconSize={IconSize.Small} />
          <Text
            fontSize={TextFontSize.Small}
            color={TextColor.Secondary}
            uppercase>
            {t('delmonicos-shared-sdk.outputs-contact.name')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <Text>{invoice.recipientHeadOffice?.name}</Text>
        </Stack>
      </Stack>

      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1} gap={GapEnum.XS} alignItems="center">
          <Icon name="marker-pin-01" iconSize={IconSize.Small} />
          <Text
            fontSize={TextFontSize.Small}
            color={TextColor.Secondary}
            uppercase>
            {t('delmonicos-shared-sdk.outputs-contact.address')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <Text>
            {invoice?.recipientHeadOffice?.address},{' '}
            {invoice?.recipientHeadOffice?.zipCode}{' '}
            {invoice?.recipientHeadOffice?.city} -{' '}
            {invoice?.recipientHeadOffice?.countryCode}
          </Text>
        </Stack>
      </Stack>

      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1} gap={GapEnum.XS} alignItems="center">
          <Icon name="building-01" iconSize={IconSize.Small} />
          <Text
            fontSize={TextFontSize.Small}
            color={TextColor.Secondary}
            uppercase>
            {t('delmonicos-shared-sdk.outputs-company.vat-number')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <Text>{invoice.recipientHeadOffice?.vatNumber}</Text>
        </Stack>
      </Stack>
    </Card>
  );
};
